// extracted by mini-css-extract-plugin
module.exports = {"memberCol":"GroupListPermission_memberCol_38Kq6"};